import React, { Component } from "react";
import Dialog from "../UiComponents/Dialog";
import getLabel from './../../utils/labels'
import person from "./../../globals/images/actors/Arthur.png";
import callIcon from "./../../globals/images/phone-icon.svg";
import vmIcon from "./../../globals/images/voicemail.svg";
import styles from "./incomingAlert.module.scss";

class IncomingAlert extends Component {
	constructor(props) {
		super(props);
		this.countDownTimer = null;
	}

	componentDidMount = () => {
		if (this.props.type === "meeting") {
			this.startCountDown();
		}
	};

	componentWillUnmount = () => {
		clearInterval(this.countDownTimer);
	};

	startCountDown = () => {
		this.countDownTimer = setInterval(() => {
			if (this.props.countdown > 0) {
				this.props.decreaseMeetingTimeLeft();
			} else {
				this.onAcceptClick();
				clearInterval(this.countDownTimer);
			}
		}, 1000);
		return this.countDownTimer;
	};

	onAcceptClick = () => {
		this.props.stopCallNotification();
		this.props.startCall({
			primaryMailId: this.props.currentCallId
		});

		//if tutorial, go to next step
		if (this.props.tutorial.isRunning) {
			setTimeout(() => {
				this.props.updateStepNumber(this.props.tutorial.stepIndex + 1);
			}, 1000);
		}
	};

	onRejectClick = () => {
		if (!window.location.href.includes("tutorial")) {
			this.props.sendCallToVoiceMail({
				primaryMailId: this.props.currentCallId,
				actionTakenAt: this.props.getTimeData().timeLeft
			});
			this.props.stopCallNotification();
		}
	};

	getFromActor = () => {
		const { actors, callDetail } = this.props;
		if (callDetail) {
			let from = callDetail.survey.fromActor;

			let actorDetails =
				actors.clients.find(actor => actor.id === from) ||
				actors.inActors.find(actor => actor.id === from);
			return actorDetails;
		}
	};

	render() {
		let actor,
			callImage,
			actorName,
			isFooterNeeded = false;
		if (this.props.type === "call") {
			actor = this.getFromActor();
			if (actor) {
				callImage = actor.gravatar;
				actorName = actor.first_name + " " + actor.last_name;
			} else {
				callImage = person;
				actorName = getLabel('label_call_cloent_POC');
			}
		}

		return this.props.type === "call" ? (
			<Dialog
				overlayClassName={styles.dialog}
				containerClassName={styles["overlay-container"]}
				isFooterNeeded={isFooterNeeded}
			>
				<div className={styles.container}>
					<img src={callImage} className={styles.image} />
					<div className={styles.textbox}>
						<div className={styles.title}>
							{actorName} {getLabel('label_calling')} <span>.</span>
							<span>.</span>
							<span>.</span>
						</div>
						<div className={styles.buttons}>
							<div
								className={styles.accept}
								id="tutorial-accept-call"
								onClick={() => this.onAcceptClick()}
							>
								<img src={callIcon} /> {getLabel('label_answer_button')}
							</div>
							<div
								className={styles.reject}
								onClick={this.onRejectClick}
							>
								<img src={vmIcon} /> {getLabel('label_send_to_voicemail_button')}
							</div>
						</div>
					</div>
				</div>
			</Dialog>
		) : (
				<div className={styles["meeting-container"]}>
					<div className={styles.meetingtitle}>{getLabel('label_team_meeting')}</div>
					<div className={styles["timer-content"]}>
						<img src={person} className={styles.meetingimage} />
						<div className={styles.text}>{getLabel('label_meeting_starts_in')}</div>
						<p className={styles.timer}>
							{`00:0${this.props.countdown}`}
						</p>
					</div>
				</div>
			);
	}
}

export default IncomingAlert;



// WEBPACK FOOTER //
// /src/components/IncomingAlert/IncomingAlert.js